import React, { Component } from 'react';
import { Layout, Row, Col, Input, Button, Typography } from 'antd';
import { Picker, List, ActivityIndicator, Toast } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import { GetSearchSurname, GetSearchPushCallback } from '../../utils/read-querystring-helper';
import localStorage from '../../utils/localStorage';
import * as SignalR from '@aspnet/signalr';
import './GuestLogin.css';

const { Content } = Layout;
const { Text } = Typography;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'templateStore',
    'translationStore',
    'loginStore',
    'authStore',
    'chatStore',
    'CmsLanguageStore',
    'webSettingStore'
)
@observer
class GuestLoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginEnabled: false,
            lastName: '',
            roomNo: '',
            animating: false
        };
    }

    componentDidMount() {
        this.props.templateStore.getActive();
        this.props.webSettingStore.getData();
        this.props.CmsLanguageStore.getActives();
        this.props.authStore.initGuestLogin();

        if (this.props.match.params.roomNumber === undefined) {
            this.props.authStore.setHasRoomNumberInUrl(false);
            this.props.authStore.setHasLastNameInUrl(false);
        } else {
            this.props.authStore.setRoomNumber(this.props.match.params.roomNumber);
            this.props.authStore.setHasRoomNumberInUrl(true);

            if (this.props.match.params.lastName === undefined) {
                this.props.authStore.setHasLastNameInUrl(false);
            } else {
                this.props.authStore.setLastname(this.props.match.params.lastName);
                this.props.authStore.setHasLastNameInUrl(true);

                this.setState({
                    animating: true
                });

                this.props.authStore.guestLogin().then((guestLoginResponse) => {
                    if (guestLoginResponse) {
                        if (!guestLoginResponse.success) {
                            this.setState({
                                animating: false
                            });
                            Toast.fail('Invalid credentials');
                        }
                        else {
                            if (guestLoginResponse.result) {
                                this.props.authStore.setGeneralConfiguration().then(() => {
                                    this.setState({
                                        animating: false
                                    });
                                    
                                    this.props.authStore.guestLog();
                                    
                                    this.props.history.push('/home');
                                })
                            } else {
                                this.setState({
                                    animating: false
                                });
                                Toast.fail('Invalid credentials');
                            }
                        }
                    } else {
                        this.setState({
                            animating: false
                        });
                        Toast.fail('Invalid credentials');
                    }
                });
            }
        }

        const searchSurname = GetSearchSurname(this);
        if (searchSurname !== null) {
            this.props.authStore.setLastname(searchSurname);
        }

        const searchPushCallback = GetSearchPushCallback(this);
        if (searchPushCallback !== null) {
            this.props.authStore.setPushcallbackUrl(searchPushCallback);
        }

        setTimeout(() => {
            if (this.props.match.params.lastName !== undefined) {
                this.props.authStore.setLastname(this.props.match.params.lastName);
            } else {
                if (localStorage.GetString('lastName')) {
                    this.props.authStore.setLastname(localStorage.GetString('lastName').replace(/["]+/g, ''));
                }

                if (localStorage.GetString('roomNo')) {
                    this.props.authStore.setRoomNumber(localStorage.GetString('roomNo').replace(/['"]+/g, ''));
                }
            }

            if (localStorage.GetString('lang')) {
                const selectedLanguage = localStorage.GetString('lang');

                const {
                    activeLanguages
                } = this.props.CmsLanguageStore;

                var language = activeLanguages.find(fi => fi.code === selectedLanguage);

                if (language) {
                    this.props.translationStore.setLanguage(selectedLanguage);
                    this.props.translationStore.setCurrentLanguageFull(selectedLanguage);
                    this.props.i18n.changeLanguage(selectedLanguage);
                    this.setState({ language: [selectedLanguage] });

                    return;
                }
            }

            const defaultLanguage = 'en';
            this.props.translationStore.setLanguage(defaultLanguage);
            this.props.translationStore.setCurrentLanguageFull(defaultLanguage);
            this.props.i18n.changeLanguage(defaultLanguage);
            this.setState({ language: [defaultLanguage] });
        }, 100);

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    // ON CHANGE

    languageOnChange = (language) => {
        const selectedLanguage = language[0];
        this.props.i18n.changeLanguage(selectedLanguage);
        this.props.translationStore.setLanguage(selectedLanguage);
        this.props.translationStore.setCurrentLanguageFull(selectedLanguage);
        this.props.templateStore.getActive();
        this.props.webSettingStore.getData();
    }

    roomNumberOnChange = (e) => {
        this.props.authStore.setRoomNumber(e.target.value);
    }

    lastNameOnChange = (e) => {
        this.props.authStore.setLastname(e.target.value);
    }

    // ON CLICK

    loadHome = () => {
        this.setState({
            animating: false
        });
        
        this.props.authStore.guestLog();
        
        this.props.history.push('/home');
    }

    guestLoginOnClick = () => {
        this.setState({
            animating: true
        });

        this.props.authStore.guestLogin().then((guestLoginResponse) => {
            if (guestLoginResponse) {
                if (!guestLoginResponse.success) {
                    this.setState({
                        animating: false
                    });
                    Toast.fail('Invalid credentials');
                }
                else {
                    if (guestLoginResponse.result) {
                        this.props.authStore.setGeneralConfiguration().then(() => {
                            if (process.env.REACT_APP_STAYCHAT_API) {
                                this.props.chatStore.auth().finally(() => {
                                    this.loadHome();
                                });
                            }
                            else {
                                this.loadHome();
                            }
                        })
                    } else {
                        this.setState({
                            animating: false
                        });
                        Toast.fail('Invalid credentials');
                    }
                }
            } else {
                this.setState({
                    animating: false
                });
                Toast.fail('Invalid credentials');
            }
        });
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const { values, hasRoomNumberInUrl } = this.props.authStore;

        const { currentLanguageFull } = this.props.translationStore;

        const { activeLanguageOptions } = this.props.CmsLanguageStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                webSettting
                                    ?
                                    <>
                                        <Layout>
                                            <Content
                                                className='login-layout stm-background-size-cover'
                                                style={{
                                                    background: `url(${webSettting.loginImageUrl})`
                                                }}>
                                                <Row>
                                                    <Col span={1} />
                                                    <Col span={22} className='stm-margin-top-100'>
                                                        <Picker
                                                            data={[activeLanguageOptions]}
                                                            title='Select Language'
                                                            cascade={false}
                                                            value={this.state.language}
                                                            okText={webSettting ? webSettting.okText : ''}
                                                            dismissText={webSettting ? webSettting.cancelText : ''}
                                                            onChange={language => this.languageOnChange(language)}
                                                            onOk={language => this.setState({ language: language })}
                                                        >
                                                            <List.Item>
                                                                <Row>
                                                                    <Col
                                                                        span={13} className='stm-text-align-right stm-padding-4'>
                                                                        <Text
                                                                            className='stm-color-white-two'
                                                                            style={{
                                                                                fontFamily: activeTemplate.templateSetting.text.fontFamily
                                                                            }}>{currentLanguageFull}</Text>
                                                                    </Col>
                                                                    <Col span={11} className='stm-text-align-left stm-padding-4'>
                                                                        <img src={require('../../assets/image/Icon/Dropdown.svg')} alt='dropdown' />
                                                                    </Col>
                                                                </Row>
                                                            </List.Item>
                                                        </Picker>
                                                    </Col>
                                                    <Col span={1} />
                                                </Row>
                                                <Row>
                                                    <Col span={1} />
                                                    <Col span={22} className='stm-border-stm-width-1 stm-border-color-white stm-border-style-solid stm-border-radius-6 stm-background-white stm-margin-top-10 stm-padding-bottom-24'>
                                                        <Row>
                                                            <Col span={1} />
                                                            <Col span={22} className='stm-text-align-center stm-margin-top-20 stm-margin-bottom-20'>
                                                                {
                                                                    webSettting.logoImageUrl
                                                                        ?
                                                                        <img className='stm-max-width-160 stm-height-auto' src={webSettting.logoImageUrl} alt='StayPlease' />
                                                                        :
                                                                        null
                                                                }
                                                            </Col>
                                                            <Col span={1} />
                                                        </Row>

                                                        {!hasRoomNumberInUrl ? (
                                                            <Row>
                                                                <Col span={1} />
                                                                <Col span={22} className='stm-margin-bottom-10'>
                                                                    <Input
                                                                        placeholder={webSettting.placeholderRoomText}
                                                                        value={values.roomNumber}
                                                                        onChange={this.roomNumberOnChange}
                                                                        style={{
                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                            color: activeTemplate.templateSetting.text.color,
                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                            height: activeTemplate.templateSetting.text.fontSize + 24
                                                                        }} />
                                                                </Col>
                                                                <Col span={1} />
                                                            </Row>
                                                        ) : (<React.Fragment></React.Fragment>)}

                                                        <Row>
                                                            <Col span={1} />
                                                            <Col span={22} className='stm-margin-bottom-10'>
                                                                <Input
                                                                    placeholder={webSettting.placeholderLastnameText}
                                                                    value={values.lastName}
                                                                    onChange={this.lastNameOnChange}
                                                                    style={{
                                                                        fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                        color: activeTemplate.templateSetting.text.color,
                                                                        fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                        height: activeTemplate.templateSetting.text.fontSize + 24
                                                                    }} />
                                                            </Col>
                                                            <Col span={1} />
                                                        </Row>

                                                        <Row>
                                                            <Col span={1} />
                                                            <Col span={22} className='stm-margin-top-10'>
                                                                <ActivityIndicator
                                                                    toast
                                                                    text='Please wait...'
                                                                    animating={this.state.animating}
                                                                />
                                                                {
                                                                    values.lastName && values.roomNumber ? (
                                                                        <Button
                                                                            onClick={this.guestLoginOnClick}
                                                                            className='stm-width-100-percent'
                                                                            style={{
                                                                                background: activeTemplate.templateSetting.buttonFooter.backgroundColor,
                                                                                color: activeTemplate.templateSetting.buttonFooter.color,
                                                                                fontSize: activeTemplate.templateSetting.buttonFooter.fontSize,
                                                                                fontFamily: activeTemplate.templateSetting.buttonFooter.fontFamily,
                                                                                height: activeTemplate.templateSetting.buttonFooter.fontSize + 32
                                                                            }}>{webSettting ? webSettting.loginText : ''}</Button>
                                                                    ) : (
                                                                        <Button
                                                                            className='stm-width-100-percent stm-opacity-60'
                                                                            style={{
                                                                                background: activeTemplate.templateSetting.buttonFooter.backgroundColor,
                                                                                color: activeTemplate.templateSetting.buttonFooter.color,
                                                                                fontSize: activeTemplate.templateSetting.buttonFooter.fontSize,
                                                                                fontFamily: activeTemplate.templateSetting.buttonFooter.fontFamily,
                                                                                height: activeTemplate.templateSetting.buttonFooter.fontSize + 32
                                                                            }}>{webSettting ? webSettting.loginText : ''}</Button>
                                                                    )
                                                                }
                                                            </Col>
                                                            <Col span={1} />
                                                        </Row>
                                                    </Col>
                                                    <Col span={1} />
                                                </Row>
                                            </Content>
                                        </Layout>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(GuestLoginPage)
